import { SHEET_VARIANTS, Sheet, SheetContent } from '@/components/Sheet';

import MenuContent from './MenuContent';

function SidebarMobile({ open, onChange }) {
	return (
		<Sheet open={open} onOpenChange={value => onChange(value)}>
			<SheetContent
				appear={SHEET_VARIANTS.LEFT}
				hasCross
				className="md:w-[464px]"
			>
				<MenuContent closeMenu={() => onChange(false)} />
			</SheetContent>
		</Sheet>
	);
}

export default SidebarMobile;
